import * as validator from "validator";
import * as moment from "moment";

export const required = function(value) {
  return value && value.length;
};

export const requiredDate = function(value) {
  return moment(value).isValid();
};

export const email = function(value) {
  return !value || (value && validator.isEmail(value));
};

export const url = function (value) {
    return !value || (value && validator.isURL(value, {require_protocol: true}));
};

export const numberRange = function(min, max, value) {
  let strValue = String(value);
  return  !strValue || (strValue && validator.isNumeric(strValue) && validator.toInt(strValue) >= min &&  validator.toInt(strValue) <= max);
};

export const maxLength = function(maxLength, value) {
  return !value || (value && value.length <= maxLength);
};

export const minLength = function(minLength, value) {
  return !value || (value && value.length >= minLength);
};

export const isWeakPassword = function(value) {
    var re = /^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,}/;  
    return !value || (value && value.length >= 8);// || re.test(value);
  };

  
export const passwordsMatch = ({ password, confirmPassword }) => {
  return password === confirmPassword;
};



// WEBPACK FOOTER //
// ./src/components/Validators/index.ts